function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
import 'swiper/css';

function defaultSwiperSettings() {
  var slidesPerView = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var speed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  var autoplay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var autoHeight = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  return {
    modules: [Navigation, Pagination, Autoplay],
    autoplay: autoplay,
    speed: speed,
    slidesPerView: slidesPerView,
    centerInsufficientSlides: true,
    autoHeight: autoHeight,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    a11y: true
  };
}

document.addEventListener("DOMContentLoaded", function () {
  //fetch any hero sliders on the page
  var sliders = document.getElementsByClassName('heroslider'); //this will hold our initialized sliders

  var initialized_sliders = []; //if we have some sliders

  if (sliders && sliders.length > 0) {
    //loop over our sliders
    for (var i = 0; i < sliders.length; i++) {
      //if this block has more than one slide
      if (sliders[i].dataset.count > 1) {
        //initialize this slider
        initialized_sliders[sliders[i].id] = new Swiper(sliders[i], _objectSpread(_objectSpread({}, defaultSwiperSettings(1, 700, {
          disableOnInteraction: false
        }, true)), {}, {
          on: {
            activeIndexChange: function activeIndexChange(swiper) {
              console.log(swiper);
              swiper.el.setAttribute('data-active', swiper.activeIndex + 1);
            }
          }
        }));
      }
    }

    document.addEventListener('click', function (event) {
      if (!event.target.matches('.slide-progress')) return; //if it's not the slide-progress bar, bail

      event.preventDefault(); //fetch the parent hero

      var hero = event.target.closest('.heroslider'); //fetch thw swiper instance we're targeting

      var swiper = initialized_sliders[hero.id]; //fetch the target index

      var index = event.target.getAttribute("data-index"); //if we have access to the swiper instance and a valid index

      if (swiper && index) {
        //navigate to the clicked slide
        swiper.slideTo(index);
      }
    }, false);
    document.addEventListener('click', function (event) {
      if (event.target.matches('#play') || event.target.matches('#pause')) {
        //fetch the parent hero
        var hero = event.target.closest('.heroslider'); //fetch thw swiper instance we're targeting

        var swiper = initialized_sliders[hero.id]; //if we've found the parent hero and have access to its swiper instance

        if (hero && swiper) {
          //this variable will indicate whether we're starting or stopping the progress animation and videos later on
          var play = false; //if the slider is currently autoplaying

          if (swiper.autoplay.running) {
            //stop it
            swiper.autoplay.stop();
          } else {
            //otherwise
            //start it again
            swiper.autoplay.start(); //set our variable to true

            play = true;
          } //fetch our play and pause icons


          var buttons = {
            'play': hero.querySelector('#play'),
            'pause': hero.querySelector('#pause')
          }; //if we're resuming playback

          if (play) {
            //set the icons accordingly
            buttons['play'].classList.add('hidden');
            buttons['pause'].classList.remove('hidden');
          } else {
            //otherwise we're pausing playback
            //set the icons
            buttons['pause'].classList.add('hidden');
            buttons['play'].classList.remove('hidden');
          } //fetch all animated progress bars


          var animations = hero.querySelectorAll('[data-animation]'); //if we have some animations

          if (animations && animations.length > 0) {
            //loop over them
            for (var _i = 0; _i < animations.length; _i++) {
              //if we're resuming playback
              if (play) {
                //restore the animation
                animations[_i].style.animationPlayState = 'running';
              } else {
                //otherwise
                //pause it
                animations[_i].style.animationPlayState = 'paused';
              }
            }
          } //fetch all videos in this slider


          var videos = hero.getElementsByTagName('video'); //if we have videos

          if (videos && videos.length > 0) {
            //loop over them
            for (var _i2 = 0; _i2 < videos.length; _i2++) {
              if (play) {
                videos[_i2].play();
              } else {
                videos[_i2].pause();
              }
            }
          }
        }
      }
    }, false);
  }
});